module.exports = __webpack_public_path__ + "img/allottee3_7-8-2021.4f0f5e07.jpg";